import React, { useState, useImperativeHandle, forwardRef, Fragment } from 'react';
import { Animated, Easing, View } from 'react-native';

import PropTypes from 'prop-types';

import Styles, { circleHeight, circleWidth } from './styles'

import Images from '../../Themes/images';


const FadingSplash = forwardRef((props, ref) => {
  const { color: borderColor } = props;

  const [scaleAnim] = useState(new Animated.Value(236.8));
  const [widthAnim] = useState(new Animated.Value(0));
  const [fadeAnim] = useState(new Animated.Value(1));

  const splashAnim = (startAfter = 1000) =>
    Animated.parallel([
      Animated.timing(scaleAnim, {
        toValue: 32,
        duration: 933.33,
        delay: startAfter + 400,
        easing: Easing.inOut(Easing.bezier(0.76, 0.0, 0.24, 1.0)),
        useNativeDriver: false,
      }),
      Animated.timing(widthAnim, {
        toValue: 1,
        duration: 900,
        delay: startAfter + 200,
        easing: Easing.inOut(Easing.bezier(0.52, 0.0, 0.74, 0.0)),
        useNativeDriver: false,
      }),
      Animated.timing(fadeAnim, {
        toValue: 0,
        duration: 400,
        delay: startAfter + 400,
        easing: Easing.inOut(Easing.bezier(0.0, 0.0, 0.58, 1.0)),
        useNativeDriver: false,
      }),
    ]);

  const startSplash = (config = {}, endSplash) => {
    const { startAfter = 1000 } = config;

    return new Promise(resolve => {
      splashAnim(startAfter).start(({ finished }) => {
        if (finished) {
          resolve({ dismissSplash: endSplash, done: true });
        }
      });
    });
  };

  const borderWidth = widthAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [circleHeight, 0],
  });

  useImperativeHandle(ref, () => ({
    startSplash: (config, endSplash) => startSplash(config, endSplash),
  }));

  return (
    <Fragment>
      <Animated.View style={[Styles.fadingContainer, { borderColor, borderWidth }]} />

      <View style={Styles.logoContainerStyle}>
        <Animated.Image
          source={Images.logo}
          style={[
            Styles.logo,
            {
              width: scaleAnim,
              height: scaleAnim,
              opacity: fadeAnim,
            },
          ]}
        />
      </View>
    </Fragment>
  );
});

FadingSplash.displayName = 'FadingSplash';

FadingSplash.propTypes = {
  color: PropTypes.string,
};

export default FadingSplash;
